import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import groupService from '../../Group/services';
import collectionCategoryService from '../../CollectionCategory/services';
import CSVReader from 'react-csv-reader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import { EmployeeSchemaObject } from '../EmployeeSchema';
import divisionService from '../../Devision/services';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { TableContentDelete } from '../../Common/Table/tableContent';
import { CommonDecryptParam } from '../../../../utils/CommonParams';

const screenCode = 'RSMEMPLOYEE';

export function EmployeeCardAddEdit(props) {

    const { screen } = props.location;
    const [title, setTitle] = useState("RSM Employee Add");
    const [buttonName, setButtonName] = useState("Save")
    const [groups, setGroups] = useState([]);
    const [employeeTypes, setEmployeeTypes] = useState([]);
    const [employeeCategories, setEmployeeCategories] = useState([]);
    const [operationEntity, setOperationEntity] = useState();
    const [collectionPoints, setCollectionPoints] = useState()
    const [isEditScreen, setIsEditScreen] = useState(false);
    const [employeeSubCategories, setEmployeeSubCategories] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [rsmArray, setRsmArray] = useState([]);
    const [field, setFeild] = useState([]);
    const [employee, setEmployee] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        employeeCode: '',
        employeeTypeID: '0',
        employeeCategoryID: '2',
        title: '0',
        firstName: '',
        secondName: '',
        lastName: '',
        gender: '0',
        dateOfBirth: new Date().toISOString().split('T')[0],
        nic: '',
        address1: '',
        address2: '',
        address3: '',
        city: '',
        countryCode: '0',
        homePhoneNo: '',
        officePhoneNo: '',
        mobileNo: '',
        email: '',
        question: '',
        answer: '',
        collectionCategoryID: '0',
        isSupplementary: false,
        registrationNumber: '',
        nameToBePrinted: '',
        employeeSubCategoryID: '2',
        designationID: '3',
        maritalStatusID: '0',
        raceID: '0',
        religionID: '0',
        rsmFeilds: rsmArray,
        fieldID: '0',
        description: '',
    });
    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const contentRowNames = ["fieldName", "description"];
    const schema = Joi.object(EmployeeSchemaObject).options({ allowUnknown: true })

    const encriptedTest = props.match.params["id"];
    const id = (encriptedTest !== undefined) ? CommonDecryptParam(props.match.params["id"]) : 0;
    const data = id > 0 ? true : false;
    const edit = id > 0 ? true : false;

    useEffect(() => {
        trackPromise(
            getPermissions(),
            getSelectedEmployeeData()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [employee.groupID])

    useEffect(() => {
        trackPromise(
            getEmployeeSubCategoriesForDropdown(),
            getDesignationsForDropdown()
        )
    }, [employee.employeeCategoryID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointIDForDropdown()
        )
    }, [employee.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint()
        )
    }, [employee.collectionPointID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDRSMEMPLOYEE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setEmployee({
            ...employee,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropdown();
        getEmployeeTypesForDropdown();
        getEmployeeCategoriesForDropdown();

        if (data && edit) {
            setTitle("Edit RSM Employee");
            setButtonName("Update");
            setIsEditScreen(true);
        } else {
            setTitle("RSM Employee Add");
        }
    }

    async function getSelectedEmployeeData() {
        const data = await services.GetRsmEemployeeByID(id);
        if (data[0] !== undefined) 
            setEditScreenData(data[0]);
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getEmployeeTypesForDropdown() {
        const result = await services.GetEmployeeTypesData();
        setEmployeeTypes(result);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntity = await divisionService.getEstatesByGroupID(employee.groupID);
        setOperationEntity(operationEntity);
    }

    async function getCollectionPointIDForDropdown() {
        const collectionPoints = await services.GetCollectionPointsByCpCategoryandOpEntity(employee.operationEntityID, employee.employeeSubCategoryID);
        setCollectionPoints(collectionPoints);
    }

    async function getEmployeeCategoriesForDropdown() {
        const employeeCategories = await services.GetEmployeeCategoriesData();
        setEmployeeCategories(employeeCategories);
    }

    async function getEmployeeSubCategoriesForDropdown() {
        const employeeCategories = await services.GetEmployeeSubCategoriesData(employee.employeeCategoryID);
        setEmployeeSubCategories(employeeCategories);
    }

    async function getDesignationsForDropdown() {
        const employeeDesignations = await services.GetEemployeeDesignationsData(employee.employeeCategoryID);
        setDesignations(employeeDesignations);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetFeildsByCollectionPointID(employee.collectionPointID);
        setFeild(fields);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>);
            }
        }
        return items;
    }

    function handleChange(e) {

        const target = e.target
        const value = target.name === 'isSupplementary' ? target.checked : target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, EmployeeSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setEmployee({
            ...employee,
            [e.target.name]: value
        });

        setErrors(error);
    }

    function handleAddRsm() {
        if ( parseInt(employee.fieldID) === 0) {
            setErrors({
                ...errors,
                rsmField : "Please select feild name."
            });
            return;
        } else {
            const error = { ...errors }
            delete error["rsmField"]
            setErrors(error);
        }

        if ( parseInt(employee.fieldID) === 0) {
            setErrors({
                ...errors,
                rsmField : "Please select feild name."
            });
            return;
        } else {
            const error = { ...errors }
            delete error["rsmField"]
            setErrors(error);
        }

        var selectedFeild = field.filter((x, index) => index === parseInt(employee.fieldID));

        var rsmArrayCopy = [...rsmArray];
        var isFeildAdded = rsmArrayCopy.filter(f => parseInt(f.fieldID) === parseInt(employee.fieldID));

        if (isFeildAdded.length > 0){
            setErrors({
                ...errors,
                rsmField : isFeildAdded[0].fieldName + " already added"
            });
            return;
        } else {
            const error = { ...errors }
            delete error["rsmField"]
            setErrors(error);
        }

        const rmsFeild = {
            fieldName: selectedFeild[0],
            fieldID: parseInt(employee.fieldID),
            description: employee.description,
            state: 1
        }

        setRsmArray([...rsmArray, rmsFeild]);
    }

    function handleClick(data) {
        var allRsmFeildS = [...rsmArray]

        var selectedFeild = allRsmFeildS.filter(x => (parseInt(x.fieldID) === parseInt(data.fieldID)));
        var indexOfSelectedFeild = 0;
        
        allRsmFeildS.forEach((x, i) => {
            if ((parseInt(x.fieldID) === parseInt(data.fieldID))) {
                indexOfSelectedFeild = i;
            }
        });

        var updatedArray = allRsmFeildS.filter(x => (parseInt(x.fieldID) !== parseInt(data.fieldID)));

        if (selectedFeild[0].state === 0) {
            allRsmFeildS[indexOfSelectedFeild].state = 2;
            setRsmArray(allRsmFeildS);
        } else {
            setRsmArray(updatedArray);
        }
    }

    async function setEditScreenData(data) {
        const feildValues = await services.GetEmployeeRsmFeilds(id);
        setRsmArray(feildValues);
        setEmployee({
            groupID: data.groupID,
            operationEntityID: data.operationEntityID,
            collectionCategoryID: data.collectionCategoryID,
            collectionPointID: data.collectionPointID,
            employeeCode: data.employeeCode,
            employeeTypeID: data.employeeTypeID,
            employeeCategoryID: '2',
            title: data.titleID,
            firstName: data.firstName,
            secondName: data.secondName,
            lastName: data.lastName,
            gender: data.genderID,
            dateOfBirth: new Date().toISOString().split('T')[0],
            nic: data.nic,
            address1: data.address1,
            address2: data.address2,
            address3: data.address3,
            city: data.city,
            countryCode: data.countryID,
            homePhoneNo: data.homePhoneNo,
            officePhoneNo: data.officePhoneNo,
            mobileNo: data.mobileNo,
            email: data.email,
            question: data.question,
            answer: data.answer,
            isSupplementary: data.isSupplementary,
            registrationNumber: data.registrationNumber,
            nameToBePrinted: data.nameToBePrinted,
            employeeSubCategoryID: '2',
            designationID: '3',
            maritalStatusID: data.maritalStatusID.toString(),
            raceID: data.raceID.toString(),
            religionID: data.religionID.toString(),
            rsmFeilds: rsmArray,
            fieldID: '0',
            description: '',
        });
    }

    async function handleSave(e) {
        e.preventDefault();

        if (rsmArray.length === 0){
            setErrors({
                ...errors,
                rsmField : "Please add atleast one Rsm field."
            });
            return;
        }

        const errorMessages = validate(schema, employee);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        var employeeDetails = {
            employeeID: (data && edit) ? parseInt(id) : 0,
            groupID: parseInt(employee.groupID),
            operationEntityID: parseInt(employee.operationEntityID),
            collectionPointID: parseInt(employee.collectionPointID),
            employeeTypeID: employee.employeeTypeID,
            employeeCategoryID: employee.employeeCategoryID,
            employeeCode: employee.employeeCode,
            titleID: employee.title,
            firstName: employee.firstName,
            secondName: employee.secondName,
            lastName: employee.lastName,
            genderID: employee.gender,
            dateOfBirth: new Date().toISOString().split('T')[0],
            nic: employee.nic,
            address1: employee.address1,
            address2: employee.address2,
            address3: employee.address3,
            city: employee.city,
            countryID: employee.countryCode,
            homePhoneNo: employee.homePhoneNo,
            officePhoneNo: employee.officePhoneNo,
            mobileNo: employee.mobileNo,
            email: employee.email,
            question: employee.question,
            answer: employee.answer,
            isSupplementary: employee.isSupplementary,
            registrationNumber: employee.registrationNumber,
            nameToBePrinted: employee.nameToBePrinted,
            collectionPointCategoryID: parseInt(employee.employeeSubCategoryID),
            designationID: parseInt(employee.designationID),
            maritalStatusID: parseInt(employee.maritalStatusID),
            raceID: parseInt(employee.maritalStatusID),
            religionID: parseInt(employee.religionID),
            rsmFeilds: rsmArray
        }

        let response;
        if (!edit) {
            response = await services.saveRsmEmployee(employeeDetails);
        } else {
            response = await services.updateRsmEmployee(employeeDetails);
        }

        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode)
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/rsmemployee' });
            }, 1500);
        }
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function clearState() {
        setRsmArray([]);
        setEmployee({
            ...employee,
            operationEntityTypeID: "0",
            collectionCategoryID: "0",
            collectionPointID: "0",
            employeeTypeID: '0',
            employeeCategoryID: '0',
            employeeCode: '',
            title: '',
            firstName: '',
            secondName: '',
            lastName: '',
            gender: '',
            dateOfBirth: new Date().toISOString().split('T')[0],
            nic: '',
            address1: '',
            address2: '',
            address3: '',
            city: '',
            countryCode: '',
            homePhoneNo: '',
            officePhoneNo: '',
            mobileNo: '',
            email: '',
            question: '',
            answer: '',
            isSupplementary: (isEditScreen) ? data.isSupplementary : '',
            registrationNumber: (isEditScreen) ? data.registrationNumber : '',
            nameToBePrinted: (isEditScreen) ? data.nameToBePrinted : '',
            employeeSubCategoryID: '2',
            designationID: '0',
            maritalStatusID: '0',
            raceID: '0',
            religionID: '0',
            rsmFeilds: rsmArray,
            fieldID: '0',
            description: '',
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div>
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path={screen === "empScreen" ? "/employee" : "/rsmemployee"}
                            />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Group *"
                                            id="groupID"
                                            name="groupID"
                                            value={employee.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled || isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Group--</option>
                                            {generateDropDownMenu(groups)}
                                        </TextField>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Estate *"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={employee.operationEntityID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select operation Entity--</option>
                                            {generateDropDownMenu(operationEntity)}
                                        </TextField>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Employee Type *"
                                            id="employeeTypeID"
                                            name="employeeTypeID"
                                            value={employee.employeeTypeID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select employee type--</option>
                                            {generateDropDownMenu(employeeTypes)}
                                        </TextField>
                                        {errors["employeeTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeTypeID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">

                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Employee Category *"
                                            id="employeeCategoryID"
                                            name="employeeCategoryID"
                                            value={employee.employeeCategoryID}
                                            disabled={true}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="2">Labour</option>
                                        </TextField>
                                        {errors["employeeCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Employee Sub Category *"
                                            id="employeeSubCategoryID"
                                            name="employeeSubCategoryID"
                                            disabled={true}
                                            value={employee.employeeSubCategoryID}
                                            onChange={(e) => handleChange(e)}>
                                            {generateDropDownMenu(employeeSubCategories)}
                                        </TextField>
                                        {errors["employeeSubCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeSubCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Collection Point *"
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={employee.collectionPointID}
                                            disabled={isEditScreen}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Collection Point--</option>
                                            {generateDropDownMenu(collectionPoints)}
                                        </TextField>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Designation *"
                                            id="designationID"
                                            name="designationID"
                                            value={employee.designationID}
                                            disabled={true}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="3">Plucker</option>
                                        </TextField>
                                        {errors["designationID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Employee Code *"
                                            name="employeeCode"
                                            id="employeeCode"
                                            value={employee.employeeCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["employeeCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["employeeCode"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Employee Details" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <TextField select fullWidth
                                            label="Title *"
                                            id="title"
                                            name="title"
                                            value={employee.title}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Title--</option>
                                            <option value="1">Mr.</option>
                                            <option value="2">Mrs.</option>
                                            <option value="3">Ms.</option>
                                        </TextField>
                                        {errors["title"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["title"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="First Name *"
                                            name="firstName"
                                            id="firstName"
                                            value={employee.firstName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["firstName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["firstName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Second Name"
                                            name="secondName"
                                            id="secondName"
                                            value={employee.secondName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["secondName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["secondName"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4">
                                        <TextField fullWidth label="Last Name *"
                                            name="lastName"
                                            id="lastName"
                                            value={employee.lastName}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["lastName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["lastName"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <TextField select fullWidth
                                            label="Gender *"
                                            id="gender"
                                            name="gender"
                                            value={employee.gender}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Gender--</option>
                                            <option value="1">Male</option>
                                            <option value="2">Female</option>
                                        </TextField>
                                        {errors["gender"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gender"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Marital Status *"
                                            id="maritalStatusID;"
                                            name="maritalStatusID"
                                            value={employee.maritalStatusID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Marital Status--</option>
                                            <option value="1">Married</option>
                                            <option value="2">Single</option>
                                        </TextField>
                                        {errors["maritalStatusID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Date Of Birth *"
                                            name="dateOfBirth"
                                            id="dateOfBirth"
                                            value={employee.dateOfBirth}
                                            type="date"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["dateOfBirth"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["dateOfBirth"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="NIC *"
                                            name="nic"
                                            id="nic"
                                            value={employee.nic}
                                            type="text"
                                            maxLength="12"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["nic"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nic"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Race *"
                                            id="raceID"
                                            name="raceID"
                                            value={employee.raceID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Race--</option>
                                            <option value="1">Sinhala</option>
                                            <option value="2">Tamil</option>
                                            <option value="3">Muslim</option>
                                            <option value="4">Other</option>
                                        </TextField>
                                        {errors["raceID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Religion *"
                                            id="religionID"
                                            name="religionID"
                                            value={employee.religionID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Religion--</option>
                                            <option value="1">Buddhist</option>
                                            <option value="2">Catholic</option>
                                            <option value="3">Hindu</option>
                                            <option value="4">Islam</option>
                                            <option value="5">Other</option>
                                        </TextField>
                                        {errors["religionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Address" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address1 "
                                            name="address1"
                                            id="address1"
                                            value={employee.address1}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address1"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address1"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address 2"
                                            name="address2"
                                            id="address2"
                                            value={employee.address2}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address2"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address2"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Address 3"
                                            name="address3"
                                            id="address3"
                                            value={employee.address3}
                                            type="text"
                                            maxLength="100"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["address3"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["address3"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="City"
                                            name="city"
                                            id="city"
                                            value={employee.city}
                                            type="text"
                                            maxLength="50"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["city"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["city"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Country *"
                                            id="countryCode"
                                            name="countryCode"
                                            value={employee.countryCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Country--</option>
                                            <option value="1">Afghanistan</option>
                                            <option value="2">Canada</option>
                                            <option value="3">France	</option>
                                            <option value="4">	Hungary</option>
                                            <option value="5">	Sri Lanka</option>
                                            <option value="6">	Ukraine</option>
                                        </TextField>
                                        {errors["countryCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["countryCode"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="card">
                            <PageHeader
                                title="Contact" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Home Phone No"
                                            name="homePhoneNo"
                                            id="homePhoneNo"
                                            value={employee.homePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["homePhoneNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["homePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Office Phone No"
                                            name="officePhoneNo"
                                            id="officePhoneNo"
                                            value={employee.officePhoneNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["officePhoneNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["officePhoneNo"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Mobile No"
                                            name="mobileNo"
                                            id="mobileNo"
                                            value={employee.mobileNo}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["mobileNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["mobileNo"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">

                                        <TextField fullWidth label="Email"
                                            name="email"
                                            id="email"
                                            value={employee.email}
                                            type="text"
                                            maxLength="25"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["email"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["email"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Verification" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Question"
                                            name="question"
                                            id="question"
                                            value={employee.question}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["question"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["question"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Answer"
                                            name="answer"
                                            id="answer"
                                            value={employee.answer}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["answer"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["answer"]}</FormHelperText>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="Card Details" />
                            <div className="card-body">
                                <div className="row row-top-gap">
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Registration Number *"
                                            name="registrationNumber"
                                            id="registrationNumber"
                                            value={employee.registrationNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                            disabled={isEditScreen}
                                        />
                                        {errors["registrationNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["registrationNumber"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Name to be printed *"
                                            name="nameToBePrinted"
                                            id="nameToBePrinted"
                                            value={employee.nameToBePrinted}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                            disabled={isEditScreen}
                                        />
                                        {errors["nameToBePrinted"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["nameToBePrinted"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="pt-3">
                                    <label>Supplementary Card</label>
                                    <div className="form-group row">
                                        <div className="col-md-4 pb-1">
                                            <input
                                                className="mr-2"
                                                id="isSupplementary"
                                                switch="none"
                                                type="checkbox"
                                                name="isSupplementary"
                                                onChange={(e) => handleChange(e)}
                                                checked={employee.isSupplementary}
                                            />
                                            <label htmlFor="isSupplementary" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <PageHeader
                                title="RSM" />
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-4 pb-1">
                                        <TextField select fullWidth
                                            label="Feild*"
                                            id="fieldID"
                                            name="fieldID"
                                            value={employee.fieldID}
                                            onChange={(e) => handleChange(e)}>
                                            <option value="0">--Select Feild--</option>
                                            {generateDropDownMenu(field)}
                                        </TextField>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4 pb-1">
                                        <TextField fullWidth label="Description *"
                                            name="description"
                                            id="description"
                                            value={employee.description}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["description"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["description"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-4">
                                        <div className="pt-2 float-left">
                                            <input
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={handleAddRsm}
                                                value="Add"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {errors["rsmField"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["rsmField"]}</FormHelperText>}
                                {(rsmArray.length > 0) ? <div className="row">
                                    <div className="col">
                                        <div className="table-responsive row-top-gap">
                                            <table className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Field Name</th>
                                                        <th>Feild Description</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentDelete
                                                        data={rsmArray.filter(x => parseInt(x.state) !== 2)}
                                                        contentRowNames={contentRowNames}
                                                        hasEdit={true}
                                                        handleClick={handleClick}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>: null}
                            </div>
                        </div>
                    </div>
                    <div>
                        <input
                            disabled={validate(schema, employee)}
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSave}
                            value={buttonName}
                        />

                        <input type="reset" className="btn btn-warning pull-right"
                            onClick={clearState}
                            value="Clear"
                            hidden={isEditScreen}
                        />
                    </div>
                    <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </div>
            </div>
        </Fragment >
    );
}